import { Injectable } from '@angular/core';
import { HttpService } from './core/http.service';
import { URLService } from './_url.service';
import { ResponseData } from './model/response.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AccountService {

  constructor(private httpService: HttpService, private URLService: URLService) { }

  login(model: any): any {
    return this.httpService.post(this.URLService.loginUrl, model);
  }

  logout(notificationToken: string): any {
    return this.httpService.post(this.URLService.logoutUrl, { notificationToken: notificationToken });
  }

  ResetPassword(email: string): Observable<ResponseData> {
    return this.httpService.post(this.URLService.resetPasswordUrl + "?Email=" + email)
  }

  register(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.registerUrl, model);
  }

  confirmEmail(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.confirmEmail, { model: model });
  }
  resendConfirmEmail(email: string): Observable<ResponseData> {
    return this.httpService.post(this.URLService.resendConfirmEmailUrl + "?email=" + email)
  }
  resetPasswordWithToken(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.resetPasswordWithTokenUrl, model);
  }

  changePassword(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.ChangePasswordUrl, model);
  }

  AddNotificationSetup(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.AddNotificationSetupUrl, model);
  }


}
